import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HippoConfirmationConfig } from '@hippo/services/confirmation/confirmation.types';

@Component({
    selector: 'hippo-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .hippo-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
            .hippo-confirmation-dialog-panel-small {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    zoom: 50% !important;
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        NgClass,
        CdkDrag,
        CdkDragHandle,
    ],
})
export class HippoConfirmationDialogComponent {
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: HippoConfirmationConfig
    ) {}
}
